export enum ScreenSize {
  EXTRA_SMALL = 0,
  SMALL = 480,
  MEDIUM = 768,
  LARGE = 1060,
  EXTRA_LARGE = 1440,
}
